import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { Input } from "@mui/material";

export const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 8,
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    transition: "all 150ms ease-in",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #e6e6e7",
    transition: "all 150ms ease-in",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
}));
